import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CreateNewFolderIcon(props: IconProps) {
    return <Icon {...props} iconKey={"create_new_folder"}/>
}
